import { ChangeDetectionStrategy, Component, Input } from '@angular/core';

enum ColumnTypeEnum {
  OFFER = 'offer',
  ADVERTISER = 'advertiser',
}

@Component({
  selector: 'gtd-crm-questions-link',
  templateUrl: './crm-questions-link.component.html',
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class CrmQuestionsLinkComponent {
  @Input() advertiser: { id: string; name: string } | null;
  @Input() offer: { id: string; name: string } | null;
  @Input() type: ColumnTypeEnum;
  @Input() rbacProperty: string;

  constructor() {}

  public readonly ColumnTypeEnum = ColumnTypeEnum;
}
